declare var window: any;

var PermissionService = {
    checkPermission: function (name: string) {
        if (window.Permissions != null) {
            if (window.Permissions.indexOf(name) != -1)
                return true;
            else
                return false;            
        }
        else {
            return false;
        }
    }
}

export default PermissionService;